module.exports = __webpack_public_path__ + "static/media/Danglar_01.bd1bc9b7.jpg";